// Module
var code = "<script id=\"wcc-components-topic-summary-instructions-header\" type=\"text/template\">\r\n    <div class=\"topic-summary__header\">\r\n        <h3 style=\"margin: 0;\" data-bind=\"text: title\"></h3>\r\n    </div>\r\n</script>";
// Exports
module.exports = code;